import { useCallback } from "react";
import { post } from "shared/data";

export const useLastOpenedShipment = () => {
    return useCallback((taskId) => post(`/receiving/shipments/lastopened/${taskId}`), []);
};
